import React, { Component } from 'react';
import { connect } from "react-redux";
import { setLoader } from "../../redux/actionCreators";
import './documentReview.css';
import MainButton from '../../components/buttons/main_button/MainButton';

const DOCUMENT_RESUME_INFO = 0;
const DOCUMENT_REVIEW = 1;
const PROCESS_TAB = 0;
const REVIEW_TAB = 1;
const TRANSFERENCE_DOCUMENT_TYPE = 'TRANSFERENCE';
const SIGNATURE_DOCUMENT_TYPE = 'DOCUMENT';
const SIGNATURE_DOCUMENT_NAME = 'DOCUMENTO';
const TRANSFERENCE_DOCUMENT_NAME = 'CONTRATO';

const SUB_COMPONENTS = {
    RESUME_INFO : DOCUMENT_RESUME_INFO,
    VIEW_DOCUMENT: DOCUMENT_REVIEW,
};

const DOCUMENT_SOURCES = {
    TRANSFERENCE: TRANSFERENCE_DOCUMENT_TYPE,
    SIGNATURE: SIGNATURE_DOCUMENT_TYPE,
}

const LABEL = {
    TRANSFERENCE: TRANSFERENCE_DOCUMENT_NAME,
    SIGNATURE: SIGNATURE_DOCUMENT_NAME,
}

const FLUX_WITH_FEA = ['full_security_fea', 'full_fea', 'fea_with_circulation_permission', 'full_fea_with_autocapture',];

class ProcessResumeInfo extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedComponent: SUB_COMPONENTS.RESUME_INFO,
        };
    }

    componentDidMount() {
        this.props.setLoader(false);
    }


    formattedNumber = (number) =>  {
        const formatter = new Intl.NumberFormat('es-CL', {
            style: 'currency',
            currency: 'CLP'
        });
        return formatter.format(number)
    };

    div = (title,data) =>   <div className='resume-info-object'>
                                <div className='resume-info-params'>
                                <div className='resume-info-field'>{title}</div>
                                <div className='resume-info-data'>{data}</div>
                            </div>
                                <div className='resume-info-line'></div>
                            </div>;

    multipleItems = (array) => <div className='multiple-items'>
                                {array.map( (element, indx) => <div key={indx}>{element}</div>)}
                                </div>

    processResumeInfoRows = () => {
        const info = this.props && this.props.stepInfo &&  this.props.stepInfo.contractResumeInfo || {};
        const rows = [];
        if(info.plate){
            rows.push(this.div('Patente vehículo',info.plate));
        }
        if(info.brand){
            const toMap = [info.brand];
            if(info.brand){
                toMap.push(info.model);
            }
            rows.push(this.div('Marca y modelo', this.multipleItems(toMap)));
        }
        if(info.salePrice){
            rows.push(this.div('Precio del vehículo', this.formattedNumber(info.salePrice)));
        }
        if(info.sellers && info.sellers.length > 0){
            rows.push(this.div('Parte vendedora', this.multipleItems(info.sellers)));
        }
        if(info.buyers && info.buyers.length > 0){
            rows.push(this.div('Parte compradora', this.multipleItems(info.buyers)));
        }
        
        return rows;
    }

    selectDocumentReviewComponent = () => this.props.selectComponent(SUB_COMPONENTS.VIEW_DOCUMENT);

    documentType = () => this.props.source === DOCUMENT_SOURCES.SIGNATURE ? LABEL.SIGNATURE.toLowerCase() : LABEL.TRANSFERENCE.toLowerCase();

    fluxWithoutECertProcess = () => !FLUX_WITH_FEA.includes(this.props.identityType);

    render() {
        return (
            <div className='resume-info-viewer'>
                <p className='resume-info-title'>REVISAR {this.documentType().toUpperCase()}</p>
                <div className='resume-info-frame'>
                   {this.processResumeInfoRows()}
                </div>
                { this.props.viewDocumentButton && this.fluxWithoutECertProcess() ?
                <div className='view-resume'>
                    <MainButton
                        outline
                        onClick={this.selectDocumentReviewComponent}
                        text={`Ver ${this.documentType()}`}
                    />
                </div>:
                <React.Fragment/>
                }
            </div>
        );
    }
}


const mapStateToProps = state => {
    return {
        stepInfo: state.stepInfo,
        loader: state.loader,
        tab: state.tab,
        source: state.source,
        identityType: state.identityType,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        setLoader(loader) {
            dispatch(setLoader(loader));
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ProcessResumeInfo);